module.exports = __webpack_public_path__ + "static/img/download_icon.4275f9d8.svg";